import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DataTable, A, Row, NoTranslate, H3 } from '@contently/toolkit';

import { get, endpoint } from '../../../utils/shared/api';
import { handleError } from '../../utils/errors';

const columnConfig = [
  {
    Header: 'Title',
    accessor: row => row,
    noTranslate: true,
    filter: {
      type: 'search',
      placeholder: 'Title...'
    },
    filterMethod: DataTable.filterByContaining(accessorValue => accessorValue.title),
    Cell: row => (
      <A href={`/stories/${row.value.id}`} title={row.value.title}>
        <NoTranslate text={row.value.title} />
      </A>
    )
  },
  {
    Header: 'Appeared in portal',
    accessor: 'contentSeen'
  },
  {
    Header: 'Link clicked',
    accessor: 'linkClick'
  },
  {
    Header: 'URL copied',
    accessor: 'copyUrl'
  },
  {
    Header: 'Emailed',
    accessor: 'email'
  },
  {
    Header: 'Shared content views',
    accessor: 'sharedUrlVisited'
  }
];

const EmptyEvents = () => (
  <Row>
    <H3>There is no analytics data for stories in this content portal.</H3>
  </Row>
);

const StoryEvents = props => {
  const { brandProfileId, contentPortalId, dates, setFetching } = props;
  const [data, setData] = useState([]);

  const fetchContentPortalEventContentData = () => {
    const params = {
      from_date: dates.startDate,
      to_date: dates.endDate
    };

    setFetching(true);
    get(
      endpoint(`/api/v1/analytics/${brandProfileId}/content_portal_aggregate_events_content/${contentPortalId}`, params)
    )
      .then(json => {
        setData(json);
        setFetching(false);
      })
      .catch(error => handleError(error));
  };

  useEffect(() => {
    if (dates.startDate && dates.endDate) {
      fetchContentPortalEventContentData();
    } 
  }, [dates]);

  if (data.length === 0) return <EmptyEvents/>;

  return (
    <Row>
      <DataTable.Table data={data} columns={columnConfig} recordNoun="story" pageSize={10} />
    </Row>
  );
};

StoryEvents.propTypes = {
  dates: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date)
  }).isRequired,
  brandProfileId: PropTypes.number.isRequired,
  contentPortalId: PropTypes.string.isRequired,
  setFetching: PropTypes.func.isRequired
};

export default StoryEvents;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_portals/story_events.jsx